export default {
  name: 'InfoBadge',
  props: {
    status: String
  },
  data: () => ({
    style: ''
  }),
  methods: {
    assignBackgroundColor(backgroundColor) {
      return `background-color: ${backgroundColor}`
    }
  },
  watch: {
    status: {
      handler(data) {
        if (data) {
          const { [data]: status } = this.$vuetify.theme
          this.style = this.assignBackgroundColor(status)
        }
      },
      immediate: true
    }
  }
}
